import { Box, Chip, styled, Typography } from "@mui/material";
import { blue, green, orange } from "@mui/material/colors";

export const AccountContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isCurrent",
})<{ isCurrent: boolean }>`
  border: 1px solid;
  border-color: ${({ theme, isCurrent }) => (isCurrent ? theme.palette.divider : theme.palette.primary.light)};
  border-radius: ${({ theme }) => theme.spacing(2)};
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(1)};
  margin: ${({ theme }) => theme.spacing(1, 0)};
  align-items: center;
`;

export const AccountContent = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  flex: 1;
  min-width: 0;
`;

export const AccountName = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isCurrent",
})<{ isCurrent: boolean }>`
  font-weight: ${({ isCurrent }) => (isCurrent ? 500 : 400)};
`;

const BaseChip = styled(Chip)`
  border-width: 0;
  font-size: ${({ theme }) => theme.typography.size.xsmall};
  height: 20px;

  .MuiChip-label {
    padding: ${({ theme }) => theme.spacing(0, 0.75)};
  }
`;

export const CurrentChip = styled(BaseChip)`
  background-color: ${({ theme }) => theme.palette.action.hover};
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const SwitchingToChip = styled(BaseChip)`
  background-color: ${green[50]};
  color: ${({ theme }) => theme.palette.success.dark};
`;

export const MemberChip = styled(BaseChip)`
  background-color: ${blue[50]};
  color: ${({ theme }) => theme.palette.info.main};
`;

export const GuestChip = styled(BaseChip)`
  background-color: ${orange[50]};
  color: ${orange[800]};
`;

export const ExternalChip = styled(BaseChip)`
  background-color: ${({ theme }) => theme.palette.action.hover};
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const AdminChip = styled(BaseChip)`
  background-color: ${green[50]};
  color: ${({ theme }) => theme.palette.success.dark};
`;
